/**
 * author ysj
 */
import { get, post, getParam } from './httpServer';

export default {
  getHomePage() {
    // return get('/api/home/homepage/');
    return get('http://101.201.171.131:8080/rest/api/bride/homepage');
  },
  searchCase(data) {
    const dataReal = {
      order_type: data.order_type,
      price_min: data.price_min * 100,
      price_max: data.price_max * 100,
      keywords: data.keywords,
      category_id_array: data.category_id_array,
      case_type: data.case_type,
      city_id: data.city_id,
      has_video: data.has_video,
      is_promotion: data.is_promotion,
      offset: data.offset,
      count: data.count,
    };
    return post('/api/user/search/case/', dataReal);
  },
  getBasicInfo() {
    return get('/api/home/basic_info/');
  },
  getCaseInfo(caseId) {
    return get(`/api/user/case/detail/${caseId}/`);
  },
  getShopInfo(shopId) {
    return get(`/api/user/shop/detail/${shopId}/`);
  },
  getShopCaseList(shopId, fromIndex) {
    return get(`/api/user/shop/${shopId}/caselist/?from=${fromIndex}`);
  },
  getFavorList(data) {
    return getParam('/api/user/favor/', data);
  },
  favorCase(caseId) {
    return post('/api/user/add/favor/', { case_id: caseId });
  },
  unFavorCase(caseId) {
    return post('/api/user/favor_cancel/', { case_id: caseId });
  },
  homePosterList(data) {
    // const dataReal = {
    //   page: 1,
    //   base: data.base || 0,
    //   themeId: data.themeId || 11,
    //   order: data.order || 1,
    //   deviceType: data.deviceType || 3,
    //   offset: data.offset,
    //   count: data.count,
    // };
    console.log(data);
    const pageNo = (data.offset / 10) + 1;
    const baseNo = data.base || 0;
    return post('http://101.201.171.131:8080/rest/api/bride/poster/list/', { page: pageNo, base: baseNo, themeId: 11, order: 2, deviceType: 4, offset: data.offset, count: data.count });
  },
  homePosterDetail(uuid) {
    return post('http://101.201.171.131:8080/rest/api/bride/poster/detail', { posterUuid: uuid });
  },
  // pay the bill
  pay(form) {
    return post('/api/user/order/add/', form);
  },
  getOrderDetail(weixinOrderId) {
    return get(`/api/user/order/detail/${weixinOrderId}/`);
  },
};



// WEBPACK FOOTER //
// ./src/service/apiHelper.js